<template>
  <div>
    <!-- Nothing right now -->
  </div>
</template>

<script>
  export default {
    name: 'Loading'
  }
</script>
